import React from "react";
import Header from "@/components/of/Header";
import Hero from "@/components/of/Hero";
import Ticker from "@/components/of/Ticker";
import WhatWeDo from "@/components/of/WhatWeDo";
import Toolbox from "@/components/of/Toolbox";
import Team from "@/components/of/Team";
import CaseStudy from "@/components/of/CaseStudy";
import Testimonials from "@/components/of/Testimonials";
import Contact from "@/components/of/Contact";
import Footer from "@/components/of/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-[#0A0A0A] overflow-x-hidden">
      <Header />
      <Hero />
      <Ticker />
      <WhatWeDo />
      <Toolbox />
      <CaseStudy />
      <Testimonials />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
}
